module.exports = __webpack_public_path__ + "img/droneblocks.aae45c41.png";